<div class="card tw-min-h-[300px]" *ngIf="node">
	<app-component-loader [loading]="loading"></app-component-loader>
	<div class="card-header tw-flex  tw-flex-row tw-items-center">
		<button ngbTooltip="Reload Data" (click)="refreshComponent()" class="active:tw-border-spacing-0 print:tw-hidden focus:tw-outline-0 h tw-border-0 tw-text-[#243670] tw-border-[#243670] tw-font-bold tw-px-2 tw-rounded">
			<i [class.fa-refresh]="!loading" [class.fa-spinner]="loading" [class.fa-spin]="loading" class="fa fa-spinner"></i>
		</button>
		<div class="tw-flex-1">
			Number of Students by Current Challenge - <span class="tw-text-gray-800">{{this.node?.name}}</span>
		</div>
		<div class="tw-flex tw-items-center" *ngIf="classrooms?.length > 1">
			<div class="tw-group tw-relative tw-cursor-pointer tw-py-2">
				<div class="tw-flex tw-items-center tw-justify-between tw-space-x-5 tw-bg-white tw-px-4 tw-border tw-min-w-[300px]">
					<div class="tw-menu-hover tw-py-2 tw-text-base tw-font-medium tw-text-black">
						{{node.name}}
					</div>
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
							stroke="currentColor" class="tw-h-6 tw-w-6">
							<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
						</svg>
					</span>
				</div>

				<div class="tw-invisible tw-absolute tw-z-50 tw-flex tw-min-w-[300px] tw-max-h-[300px] tw-overflow-y-auto tw-flex-col tw-bg-white tw-py-1 tw-px-4 tw-text-gray-800 tw-shadow group-hover:tw-visible">
					<div class="tw-my-2 tw-block tw-border-gray-100 tw-font-semibold hover:tw-text-black tw-text-left  tw-text-ellipsis"
						[class.tw-text-blue-500]="selectedSchool.id === node.id"
						[class.tw-text-gray-500]="selectedSchool.id !== node.id"
						(click)="onNodeChange(selectedSchool)">
						{{selectedSchool.name}}
					</div>
					<div *ngFor="let classroom of classrooms"
						class="tw-my-2 tw-pl-2 tw-block tw-border-gray-100 tw-font-semibold hover:tw-text-black tw-text-left  tw-text-ellipsis"
						[class.tw-text-blue-500]="classroom.id === node.id"
						[class.tw-text-gray-500]="classroom.id !== node.id"
						(click)="onNodeChange(classroom)">
						{{classroom.name}}
					</div>
				</div>
			</div>
		</div>
		<div class="tw-flex tw-ml-8">
			<button type="button" (click)="this.loadAllStudents()" class="tw-flex tw-bg-[#6b6b6b] tw-text-white tw-py-2 tw-px-4 btn">List Students</button>
		</div>

	</div>

	<ng-template #details let-modal id="details">
		<div [class]="'tw-bg-[' + color + '] tw-text-white tw-p-4'">
			<span class="modal-title tw-text-base tw-font-bold">{{detailsTitle}}</span>
			<span *ngIf="questionKey" class="tw-font-extralight tw-text-base tw-m-2">Challenge {{questionKey}}</span>
			<button type="button" class="close tw-text-white" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body tw-p-0">

		<table id="per-challenge-table" class="tw-table-auto tw-w-full tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-sm">
			<thead class="tw-bg-white tw-border-b tw-border-gray-200 tw-sticky tw-top-0 tw-z-10 tw-shadow-sm">
				<tr>
					<th *ngFor="let column of sortableColumns"
							class="tw-px-4 tw-py-2 tw-font-semibold tw-text-gray-700 tw-border-r tw-border-gray-200 tw-last:tw-border-r-0"
							[class.tw-cursor-pointer]="column.sortable"
							[class.tw-text-left]="column.key === 'classroom.name' || column.key === 'lname' || column.key === 'fname'"
							[class.tw-text-center]="column.key === 'grade' || column.key === 'timesAssessed' || column.key === 'lastTestDate'"
							[class.tw-whitespace-normal]="column.key === 'timesAssessed' || column.key === 'lastTestDate'"
							(click)="column.sortable && updateSort(column.key)">
						<div class="tw-flex tw-items-center" [class.tw-justify-start]="column.key === 'classroom.name' || column.key === 'lname' || column.key === 'fname'"
							 [class.tw-justify-center]="column.key === 'grade' || column.key === 'timesAssessed' || column.key === 'lastTestDate'">
							<i *ngIf="column.sortable" class="fa tw-mr-1" [ngClass]="{
								'fa-sort tw-text-gray-400': sortState.key !== column.key,
								'fa-sort-up tw-text-blue-600': sortState.key === column.key && sortState.direction === 'asc',
								'fa-sort-down tw-text-blue-600': sortState.key === column.key && sortState.direction === 'desc'
							}"></i>
							<span>{{ column.label }}</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody class="tw-divide-y">
				<tr *ngFor="let participant of participantsTable let i = index" class="hover:tw-bg-blue-50/50 tw-transition-colors tw-duration-150">
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-900 tw-font-medium tw-max-w-[120px] tw-truncate" [title]="participant.classroom.name">{{ participant.classroom.name }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700">{{ participant.lname }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700">{{ participant.fname }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700 tw-text-center">{{ participant.characteristics?.grade || '-' }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700 tw-text-center">{{ participant.timesAssessed }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700 tw-whitespace-nowrap">{{ participant.lastAssessmentDate  }}</td>
					<td class="tw-px-3 tw-py-1">
						<div class="tw-flex tw-justify-center">
							<button class="tw-text-gray-400 hover:tw-text-blue-600 tw-cursor-pointer tw-transition-colors tw-duration-150 tw-p-1 tw-rounded hover:tw-bg-blue-50" (click)="goToChildPage(participant)" title="View Details">
								<i class="fa fa-external-link tw-text-sm"></i>
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		</div>
		<div class="modal-footer">
			<app-download-table-button
				[count]="participantsTable?.length || 0"
				tableId="per-challenge-table"
				[filename]="detailsTitle + (questionKey ? ' Challenge ' + questionKey : '') + ' ' + this.node.name"
				[excludedColumns]="['View']">
			</app-download-table-button>

			<button type="button" class="btn btn-secondary" (click)="modal.close('Save click')">Close</button>
		</div>
	</ng-template>

	<ng-template #allstudents let-modal id="all-students">
		<div [class]="'tw-bg-[' + color + '] tw-text-white tw-p-4'">
			<span class="modal-title tw-text-base tw-font-bold">{{detailsTitle}}</span>
			<span *ngIf="questionKey" class="tw-font-extralight tw-text-base tw-m-2">Challenge {{questionKey}}</span>
			<button type="button" class="close tw-text-white" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body tw-max-h-[70vh] tw-overflow-y-auto tw-p-0">

		<table id="all-students-table" class="tw-table-auto tw-w-full tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-sm">
			<thead class="tw-bg-white tw-border-b tw-border-gray-200 tw-sticky tw-top-0 tw-z-20 tw-shadow-sm">
				<tr>
					<th *ngFor="let column of sortableColumnsAllStudents"
							class="tw-px-4 tw-py-2 tw-font-semibold tw-text-gray-700 tw-border-r tw-border-gray-200 tw-last:tw-border-r-0"
							[class.tw-cursor-pointer]="column.sortable"
							[class.tw-text-left]="column.key === 'classroom.name' || column.key === 'lname' || column.key === 'fname'"
							[class.tw-text-center]="column.key === 'grade' || column.key === 'timesAssessed' || column.key === 'lastTestDate'"
							[class.tw-whitespace-normal]="column.key === 'timesAssessed' || column.key === 'lastTestDate'"
							(click)="column.sortable && updateSort(column.key)">
						<div class="tw-flex tw-items-center" [class.tw-justify-start]="column.key === 'classroom.name' || column.key === 'lname' || column.key === 'fname'"
							 [class.tw-justify-center]="column.key === 'grade' || column.key === 'timesAssessed' || column.key === 'lastTestDate'">
							<i *ngIf="column.sortable" class="fa tw-mr-1" [ngClass]="{
								'fa-sort tw-text-gray-400': sortState.key !== column.key,
								'fa-sort-up tw-text-blue-600': sortState.key === column.key && sortState.direction === 'asc',
								'fa-sort-down tw-text-blue-600': sortState.key === column.key && sortState.direction === 'desc'
							}"></i>
							<span>{{ column.label }}</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody class="tw-divide-y">
				<tr *ngFor="let participant of participantsTable let i = index" class="hover:tw-bg-blue-50/50 tw-transition-colors tw-duration-150">
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-900 tw-font-medium tw-max-w-[120px] tw-truncate" [title]="participant.classroom.name">{{ participant.classroom.name }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700">{{ participant.lname }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700">{{ participant.fname }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700 tw-text-center">{{ participant.characteristics?.grade || '-' }}</td>

					<td class="tw-px-3 tw-py-1 tw-whitespace-nowrap tw-relative">
						<!-- Phase Indicator - Vertical Colored Bar -->
						<div class="tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-6 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center"
							[ngClass]="{
								'tw-bg-[#fcc200]': participant.currentChallenge?.challenge === 0 || participant.currentChallenge?.phase === 'complete' || participant.currentChallenge?.assessmentBookId === 'complete',
								'tw-bg-[#B65250]': (participant.currentChallenge?.challenge !== 0 && participant.currentChallenge?.challenge !== null && participant.currentChallenge?.challenge !== undefined) && (participant.currentChallenge?.phase === 1 || participant.currentChallenge?.assessmentBookId === '1011' || participant.currentChallenge?.assessmentBookId === 1011),
								'tw-bg-[#7D5FAA]': (participant.currentChallenge?.challenge !== 0 && participant.currentChallenge?.challenge !== null && participant.currentChallenge?.challenge !== undefined) && (participant.currentChallenge?.phase === 2 || participant.currentChallenge?.assessmentBookId === '1012' || participant.currentChallenge?.assessmentBookId === 1012),
								'tw-bg-[#435F90]': (participant.currentChallenge?.challenge !== 0 && participant.currentChallenge?.challenge !== null && participant.currentChallenge?.challenge !== undefined) && (participant.currentChallenge?.phase === 3 || participant.currentChallenge?.assessmentBookId === '1013' || participant.currentChallenge?.assessmentBookId === 1013)
							}">
							<span class="tw-text-xs tw-font-bold tw-text-white tw-font-serif">
								{{ participant.currentChallenge?.challenge !== 0 ? getPhaseLabel(participant.currentChallenge?.phase) : '' }}
							</span>
						</div>

						<!-- Progress Bar -->
						<div class="tw-absolute tw-left-6 tw-right-6 tw-top-0 tw-bottom-0 tw-overflow-hidden tw-flex tw-items-center tw-justify-left tw-p-2">
							<div [ngClass]="getProgressBarClass(participant.currentChallenge)"
								[style.width.%]="getChallengeProgress(participant.currentChallenge?.challenge)">
							</div>
							<span class="tw-relative tw-z-10 tw-text-xs tw-font-bold tw-text-black">
								{{ participant.currentChallenge?.challenge === 0 ? 'Complete' : (participant.currentChallenge?.questionNumber || 0) }}
							</span>
						</div>
					</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700 tw-text-center">{{ participant.timesAssessed }}</td>
					<td class="tw-px-3 tw-py-1 tw-text-sm tw-text-gray-700 tw-whitespace-nowrap">{{ participant.lastTestDate }}</td>
					<td class="tw-px-3 tw-py-1">
						<div class="tw-flex tw-justify-center">
							<button class="tw-text-gray-400 hover:tw-text-blue-600 tw-cursor-pointer tw-transition-colors tw-duration-150 tw-p-1 tw-rounded hover:tw-bg-blue-50" (click)="goToChildPage(participant)" title="View Details">
								<i class="fa fa-external-link tw-text-sm"></i>
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		</div>
		<div class="modal-footer">
			<app-download-table-button
				[count]="participantsTable?.length || 0"
				tableId="all-students-table"
				[filename]="'All Students ' + this.node.name"
				[excludedColumns]="['View']">
			</app-download-table-button>

			<button type="button" class="btn btn-secondary" (click)="modal.close('Save click')">Close</button>
		</div>
	</ng-template>


	<div *ngIf="!loading && !data" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16 tw-text-gray-400">
		<i class="fa fa-bar-chart tw-text-4xl tw-mb-3 tw-text-gray-300"></i>
		<p class="tw-text-base tw-font-medium">No data available</p>
		<p class="tw-text-sm">There are no assessment results to display for this selection.</p>
	</div>

	<div [class.tw-hidden]="!data" class="tw-flex ">
		<div class="tw-w-full tw-flex-auto ">
			<div class="chart-container"></div>
		</div>
		<button (click)="toggleCollapse()" class="tw-bg-gray-200 tw-px-2 ">
			<i class="fa tw-text-xl" [ngClass]="{'fa-chevron-right': !isCollapsed, 'fa-chevron-left': isCollapsed}"></i>
		</button>
		<div class="tw-border-l tw-p-2 tw-w-64 tw-border-gray-300 tw-shadow-lg" [ngClass]="{'!tw-w-0 !tw-p-0': isCollapsed}">
			<div class="tw-visible" [ngClass]="{'tw-hidden': isCollapsed}">
			<!-- Statistics Cards -->
			<div class="tw-mb-4 tw-grid tw-grid-cols-2 tw-gap-2">
				<div class="tw-bg-green-50 tw-rounded-md tw-p-2.5 tw-border tw-border-green-100">
					<div class="tw-text-xs tw-text-gray-500 tw-mb-1">Assessed</div>
					<div class="tw-text-2xl tw-font-semibold tw-text-gray-800">{{ getSelectedPhasesSum() }}</div>
				</div>
				<div class="tw-bg-blue-50 tw-rounded-md tw-p-2.5 tw-border tw-border-blue-100">
					<div class="tw-text-xs tw-text-gray-500 tw-mb-1 tw-whitespace-nowrap">Not Assessed</div> <!-- no wrap text -->
					<div class="tw-text-2xl tw-font-semibold tw-text-gray-800">{{ getNotAssessedCount() }}</div>
				</div>
			</div>


			<!-- Divider -->
			<div class="tw-border-t tw-border-gray-200 tw-my-4"></div>

			<div class="tw-mb-4">
				<h3 class="tw-text-md tw-font-bold tw-text-gray-600 tw-mb-3">Phase Breakdown</h3>
				<div class="tw-mt-2 tw-space-y-2">
					<div class="tw-flex tw-items-center tw-justify-between tw-py-1.5 hover:tw-bg-gray-50 tw-rounded tw-px-1 tw-transition-colors tw-cursor-pointer" (click)="onPhaseClick('phase1')">
						<label class="tw-flex tw-items-center tw-space-x-2 tw-cursor-pointer tw-flex-1">
							<i class="fa tw-text-xl fa-check-square tw-text-[#B65250]"  [ngClass]="{'fa-square-o': !selectedPhases.has('phase1'), 'fa-check-square': selectedPhases.has('phase1')}"></i>
							<span class="tw-text-gray-700 tw-text-sm">Phase I</span>
						</label>
						<span class='tw-px-2.5 tw-py-1 tw-rounded-full tw-bg-[#B65250]/10 tw-text-[#B65250] tw-font-semibold tw-text-sm'>{{ getPhaseSum(data?.[1011]) }}</span>
					</div>
					<div class="tw-flex tw-items-center tw-justify-between tw-py-1.5 hover:tw-bg-gray-50 tw-rounded tw-px-1 tw-transition-colors tw-cursor-pointer" (click)="onPhaseClick('phase2')">
						<label class="tw-flex tw-items-center tw-space-x-2 tw-cursor-pointer tw-flex-1">
							<i class="fa tw-text-xl fa-check-square tw-text-[#7D5FAA]" [ngClass]="{'fa-square-o': !selectedPhases.has('phase2'), 'fa-check-square': selectedPhases.has('phase2')}"></i>
							<span class="tw-text-gray-700 tw-text-sm">Phase II</span>
						</label>
						<span class='tw-px-2.5 tw-py-1 tw-rounded-full tw-bg-[#7D5FAA]/10 tw-text-[#7D5FAA] tw-font-semibold tw-text-sm'>{{ getPhaseSum(data?.[1012]) }}</span>
					</div>
					<div class="tw-flex tw-items-center tw-justify-between tw-py-1.5 hover:tw-bg-gray-50 tw-rounded tw-px-1 tw-transition-colors tw-cursor-pointer" (click)="onPhaseClick('phase3')">
						<label class="tw-flex tw-items-center tw-space-x-2 tw-cursor-pointer tw-flex-1">
							<i class="fa tw-text-xl fa-check-square tw-text-[#435F90]"  [ngClass]="{'fa-square-o': !selectedPhases.has('phase3'), 'fa-check-square': selectedPhases.has('phase3')}"></i>
							<span class="tw-text-gray-700 tw-text-sm">Phase III</span>
						</label>
						<span class='tw-px-2.5 tw-py-1 tw-rounded-full tw-bg-[#435F90]/10 tw-text-[#435F90] tw-font-semibold tw-text-sm'>{{ getPhaseSum(data?.[1013]) }}</span>
					</div>

					<div class="tw-flex tw-items-center tw-justify-between tw-py-1.5 hover:tw-bg-gray-50 tw-rounded tw-px-1 tw-transition-colors tw-cursor-pointer" (click)="onPhaseClick('complete')">
						<label class="tw-flex tw-items-center tw-space-x-2 tw-cursor-pointer tw-flex-1">
							<i class="fa tw-text-xl fa-check-square tw-text-yellow-500"  [ngClass]="{'fa-square-o': !selectedPhases.has('complete'), 'fa-check-square': selectedPhases.has('complete')}"></i>
							<span class="tw-text-gray-700 tw-text-sm">Complete</span>
						</label>
						<span class='tw-px-2.5 tw-py-1 tw-rounded-full tw-bg-yellow-500/10 tw-text-yellow-600 tw-font-semibold tw-text-sm'>{{ participantsComplete?.count || 0 }}</span>
					</div>
				</div>
				</div>
			</div>
		</div>
	</div>
</div>




<!--
<div class="tw-bg-[#d8ab19] tw-p-4 tw-text-white"></div>
<div class="tw-bg-[#B65250] tw-p-4 tw-text-white"></div>
<div class="tw-bg-[#7D5FAA] tw-p-4 tw-text-white"></div>
<div class="tw-bg-[#435F90] tw-p-4 tw-text-white"></div> -->
